import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutOrderSummaryComponent } from '@spartacus/checkout/base/components';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { KnBrOrderSummaryComponent } from '../../kn-br-cart-shared/kn-br-order-summary/kn-br-order-summary.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'cx-checkout-order-summary',
    templateUrl: './kn-br-checkout-order-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [KnBrOrderSummaryComponent, AsyncPipe]
})
export class KnBrCheckoutOrderSummaryComponent extends CheckoutOrderSummaryComponent {
  constructor(protected activeCartService: ActiveCartService) {
    super(activeCartService);
  }
}
